import React, { useEffect, useState } from "react";
import { ExerciseTypeContainer } from "./ExerciseTypeContainer";
import { useExercise } from "../adapter/StudentExerciseContext";

type ComprehensionQuestionProps = {
  item: {
    id: string;
    title: string;
    description?: string;
    question: string;
    answer: string;
    type: string;
    order: number;
    moduleId: string;
    packageId: string | null;
  };
  moduleId?: string;
};

export const ComprehensionQuestion: React.FC<ComprehensionQuestionProps> = ({
  item,
  moduleId,
}) => {
  return (
    <ExerciseTypeContainer
      item={{
        id: item.id,
        type: "comprehension_question",
        moduleId: moduleId || item.moduleId,
      }}
      moduleId={moduleId || item.moduleId}
      title1="Compreensão de texto"
      title2={item.title}
      exerciseNumber={`exercício n. ${item.order + 1}`}
    >
      <ComprehensionQuestionBody item={item} />
    </ExerciseTypeContainer>
  );
};

const ComprehensionQuestionBody: React.FC<{
  item: ComprehensionQuestionProps["item"];
}> = ({ item }) => {
  const { verify, registerVerifyHandler, setCanVerify, status } = useExercise();
  const [answer, setAnswer] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [feedback, setFeedback] = useState<string>("");

  const handleAnswerChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setAnswer(e.target.value);
    setIsVerified(false);
    setIsCorrect(false);
    setFeedback("");
  };

  const handleVerify = async () => {
    if (!answer.trim()) return;

    setIsVerifying(true);

    try {
      const result = await verify(answer);

      setIsCorrect(result.isCorrect);
      setFeedback(result.feedback || "");
      setIsVerified(true);
    } catch (error) {
      console.error("Erro ao verificar resposta:", error);
      setFeedback("Ocorreu um erro ao verificar sua resposta. Tente novamente.");
      setIsCorrect(false);
      setIsVerified(true);
    } finally {
      setIsVerifying(false);
    }
  };

  useEffect(() => {
    setCanVerify(Boolean(answer.trim()));
  }, [answer, setCanVerify]);

  useEffect(() => {
    registerVerifyHandler(handleVerify);
  });

  const locked = isVerifying || isVerified || status === "verifying";

  return (
    <div className="mt-4 space-y-4">
      <div className="font-medium">{item.question}</div>

      <textarea
        value={answer}
        onChange={handleAnswerChange}
        placeholder="Escreva sua resposta aqui..."
        className={`w-full h-24 p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
          isVerified
            ? isCorrect
              ? "border-green-300 bg-green-50"
              : "border-red-300 bg-red-50"
            : "border-gray-300"
        }`}
        disabled={locked}
      />

      {isVerified && feedback && (
        <div className="mt-2">
          <p>{feedback}</p>
        </div>
      )}
    </div>
  );
};
